// assets
import { IconArrowAutofitContent, IconBuildingSkyscraper,IconFileSettings } from '@tabler/icons';
import contentMaster from '../../../../assets/svg/contentMaster'
// import { IconFileSettings } from '@tabler/icons-react';
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const content = {
    id: 'content1',
    title: '',
    type: 'group',
    children: [
        {
            id: 'content11',
            title: 'Content',
            tooltip:"Content",
            type: 'collapse',
            // url: `/contents`,
            icon: IconFileSettings,
            breadcrumbs: false,
        }
    ]
};

export default content;
